import { motion } from 'framer-motion';
import { createStyles } from '@mantine/core';
import { Carousel } from '@mantine/carousel';
import { useState } from 'react';
// Import AOS Animation
import Aos from 'aos';
import 'aos/dist/aos.css';

import FeatureCompo from '../components/featureSepakat/feature-component';
import JumboTron2 from '../components/jumbotron-2/jumbotron2-component';
import JumboTron3Compo from '../components/jumbotron-3/jumbotron3-component';
import PartnersCompo from '../components/partners/partners-component';
import { useEffect } from 'react';
import { FooterCompo } from '../components';

const imagePartner = [
  { image: '../assets/images/logo/potraitlogo/potrait1.jpg' },
  { image: '../assets/images/logo/potraitlogo/potrait2.jpeg' },
  { image: '../assets/images/logo/potraitlogo/potrait3.jpg' },
  { image: '../assets/images/logo/potraitlogo/potrait4.jpeg' },
  { image: '../assets/images/logo/potraitlogo/potrait5.jpeg' },
  { image: '../assets/images/logo/potraitlogo/potrait6.jpeg' },
  { image: '../assets/images/logo/potraitlogo/potrait7.jpeg' },
  { image: '../assets/images/logo/potraitlogo/potrait8.jpeg' },
  { image: '../assets/images/logo/potraitlogo/potrait9.jpeg' },
];

const useStyle = createStyles((theme) => ({
  app: {
    overflow: 'hidden',
  },
  title: {
    fontFamily: 'Poppins, sans-serif',
    color: '#F56600',
    fontSize: 48,
    fontWeight: 700,
    marginTop: 50,
    marginBottom: 30,
  },
}));
const AboutUsPage = (props) => {
  const [logo, setLogo] = useState(imagePartner);
  const { classes } = useStyle();
  useEffect(() => {
    Aos.init({
      duration: 200,
      easing: 'ease-in-sine',
      offset: 200,
      delay: 100,
    });
  }, []);
  return (
    <motion.div
      initial={{ width: 0 }}
      animate={{ width: '100%' }}
      exit={{ x: window.innerWidth, transition: { duration: 0.1 } }}
    >
      <div className={classes.app} data-aos="fade-up">
        <JumboTron3Compo data-aos="fade-up" />
        <h1 className={`${classes.title} text-center`}>Layanan Kami</h1>
        <FeatureCompo />
        <h1 className={`${classes.title} text-center`}>
          Kerjasama dan Kemitraan
        </h1>
        <PartnersCompo />;
        <JumboTron2 />
        <FooterCompo />
      </div>
    </motion.div>
  );
};

export default AboutUsPage;
